import Checkbox from "@material-ui/core/Checkbox";
import Collapse from "@material-ui/core/Collapse";
import Radio from "@material-ui/core/Radio";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  CommonReducerAction,
  ExtraTimeData,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../Assets/Images/aaa.png";
import FloatValues from "../../../../../Component/FloatValues";
import InputValues from "../../../../../Component/InputValues";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
  customWidth: {
    maxWidth: 300,
    height: 160,
    maxHeight: "500px !important",
  },
});

class WorkingDay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      next: false,
      isworkingbenefit: false,
      expanded03: false,
      expanded04: false,
      expanded07: false,
      // expanded08: true,
      requiredhour: 0,
      creditcompoff: 0,
      combHours: 0,
      combMin: 0,
      accumulationmonths: 0,
      maxearningcompoff: 0,
      buffertime: 0,
      isconsiderbuffertime: false,
      maxearninghour: 0,
      isaccumulation: false,
      error: [false, false, false, false, false],
      isperhour: false,
      benefittypeid: 2,
    };
    this.onBeforeUpload = this.onBeforeUpload.bind(this);
    this.accumulationchange = this.accumulationchange.bind(this);
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.getDataFromReducer();
    this.props.onRef({
      onNext: this.validateNext,
    });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
    this.props.StepError(2, false);
  }

  accumulationchange(flag) {
    console.log("flag: ", flag);
    const { extraTimeDataReducer } = this.props;
    const acc = this.state.isaccumulation;
    this.setState(
      {
        isaccumulation: !this.state.isaccumulation,
        accumulationmonths: !this.state.isaccumulation
          ? this.state.accumulationmonths
          : 0,
      },
      () => {
        extraTimeDataReducer.extratime[0].benefittypeid = 2;
        extraTimeDataReducer.extratime[0].isaccumulation = !acc;
        extraTimeDataReducer.extratime[0].isaccumulation =
          this.state.accumulationmonths;
        this.props.ExtraTimeData({ ...extraTimeDataReducer });
      },
    );
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  getDataFromReducer() {
    const { extraTimeDataReducer } = this.props;
    const { isworkingbenefit } = extraTimeDataReducer.extratime[0];
    this.setState({ isworkingbenefit });
    if (isworkingbenefit) {
      this.setState({
        benefittypeid: extraTimeDataReducer.extratime[0].benefittypeid,
        isperhour: extraTimeDataReducer.extratime[0].isperhour,
      });
      if (extraTimeDataReducer.extratime[0].benefittypeid == 1) {
        let { maxearninghour } = extraTimeDataReducer.extratime[0];
        maxearninghour = maxearninghour.split(":");
        maxearninghour = Number(maxearninghour[0]);
        if (!extraTimeDataReducer.extratime[0].isperhour) {
          let { requiredhour } = extraTimeDataReducer.extratime[0];
          requiredhour = requiredhour.split(":");
          requiredhour = Number(requiredhour[0]);
          this.setState({ maxearninghour, requiredhour, isperhour: false }); // , expanded06: true, expanded05: false
        } else this.setState({ maxearninghour, isperhour: true }); // expanded06: false, expanded05: true,
      } else if (extraTimeDataReducer.extratime[0].benefittypeid == 2) {
        const { creditcompoff } = extraTimeDataReducer.extratime[0];
        const { maxearningcompoff } = extraTimeDataReducer.extratime[0];
        if (!extraTimeDataReducer.extratime[0].isperhour) {
          const { accumulationmonths } = extraTimeDataReducer.extratime[0];
          let { requiredhour } = extraTimeDataReducer.extratime[0];
          requiredhour = requiredhour.split(":");
          const combHours = requiredhour[0];
          const combMin = requiredhour[1];
          this.setState({
            creditcompoff,
            maxearningcompoff,
            combHours,
            combMin,
            accumulationmonths,
            isaccumulation: accumulationmonths ? true : false,
            isperhour: false,
          }); // expanded10: true,
        } else {
          this.setState({ creditcompoff, maxearningcompoff, isperhour: true }); // , expanded09: true
        }
      }
    }
    if (extraTimeDataReducer.extratime[0].buffertime != "00:00:00") {
      let { buffertime } = extraTimeDataReducer.extratime[0];
      buffertime = buffertime.split(":");
      let hours = Number(buffertime[0]);
      hours = Number(hours * 60);
      const minutes = Number(buffertime[1]);
      buffertime = Number(hours + minutes);
      this.setState({
        buffertime,
        isconsiderbuffertime:
          extraTimeDataReducer.extratime[0].isconsiderbuffertime,
        expanded07: true,
      });
    }
  }

  clearReducer() {
    const { extraTimeDataReducer } = this.props;
    this.setState(
      {
        maxearninghour: 0,
        requiredhour: 0,
        creditcompoff: 0,
        maxearningcompoff: 0,
        accumulationmonths: 0,
        combHours: 0,
        combMin: 0,
      },
      () => {
        extraTimeDataReducer.extratime[0].maxearninghour = "00:00:00";
        extraTimeDataReducer.extratime[0].requiredhour = "00:00:00";
        extraTimeDataReducer.extratime[0].creditcompoff = 0;
        extraTimeDataReducer.extratime[0].maxearningcompoff = 0;
        extraTimeDataReducer.extratime[0].accumulationmonths = 0;
        extraTimeDataReducer.extratime[0].isaccumulation = false;
      },
    );
    if (this.state.isworkingbenefit == false) {
      this.clearBuffer();
    }
    this.props.ExtraTimeData({ ...extraTimeDataReducer });
    this.clearExtraTimePolicy();
  }

  handleExpandClick01 = () => {
    const { extraTimeDataReducer } = this.props;
    this.setState(
      {
        isworkingbenefit: !this.state.isworkingbenefit,
      },
      () => {
        if (extraTimeDataReducer.isdraft == false) {
          this.props.StepError(4, true);
        }
        if (this.state.isworkingbenefit == true) {
          this.setState({ next: true });
        } else {
          this.setState({
            next: false,
            expanded03: false,
            expanded04: false,
            isperhour: false,
            expanded07: false,
            expanded09: false,
            expanded10: false,
            benefittypeid: 0,
          });
          extraTimeDataReducer.extratime[0].benefittypeid = 0;
        }
        extraTimeDataReducer.extratime[0].isworkingbenefit =
          this.state.isworkingbenefit;
        extraTimeDataReducer.extratime[0].isperhour = false;
        this.props.ExtraTimeData({ ...extraTimeDataReducer });
        this.clearReducer();
      },
    );
  };

  clearExtraTimePolicy = () => {
    const { extraTimeDataReducer } = this.props;
    extraTimeDataReducer.isetapprovalrequired = false;
    extraTimeDataReducer.ispastdateallowed = false;
    extraTimeDataReducer.isseparatebalance = false;
    extraTimeDataReducer.ispayableapproverequired = false;
    extraTimeDataReducer.iscompoffapproverequired = false;
    extraTimeDataReducer.extratimecompoffpolicy = [
      {
        lapsetypeid: 0,
        lapsedays: 0,
        isattachment: false,
        attachmentdurationlimit: 0,
        attachmentnote: "",
        maxleave: 0,
        maxdurationtypeid: 0,
        consecutiveleave: 0,
        consecutivedurationtypeid: 0,
        allowedhalfday: false,
        isfurtureappallowed: false,
        minleavecountforapp: 0,
        notifyinadvanceday: 0,
        notifynotbeforeday: 0,
        ispastappallowed: false,
        apppastday: 0,
      },
    ];
    this.props.ExtraTimeData({ ...extraTimeDataReducer });
  };

  handleExpandClick03(id) {
    this.setState({ benefittypeid: id }, () => {
      this.clearReducer();
      this.setState({ isperhour: false, next: false }, () => {
        const { extraTimeDataReducer } = this.props;
        if (extraTimeDataReducer.isdraft == false) {
          this.props.StepError(4, true);
        }
        extraTimeDataReducer.extratime[0].benefittypeid = id;
        extraTimeDataReducer.extratime[0].isperhour = false;
        this.props.ExtraTimeData({ ...extraTimeDataReducer });
      });
    });
  }

  handleExpandClick05 = () => {
    const perhour = this.state.isperhour;
    this.setState(
      (state) => ({ isperhour: !state.isperhour }),
      () => {
        const { extraTimeDataReducer } = this.props;
        extraTimeDataReducer.extratime[0].benefittypeid = 2;
        extraTimeDataReducer.extratime[0].isperhour = !perhour;
        this.props.ExtraTimeData({ ...extraTimeDataReducer });
        this.clearReducer();
      },
    );
  };

  clearBuffer() {
    const { extraTimeDataReducer } = this.props;
    extraTimeDataReducer.extratime[0].buffertime = "00:00:00";
    extraTimeDataReducer.extratime[0].isconsiderbuffertime = false;
    extraTimeDataReducer.extratime[0].benefittypeid = 2;
    this.props.ExtraTimeData({ ...extraTimeDataReducer });
    this.setState({ buffertime: 0, isconsiderbuffertime: false });
  }

  handleExpandClick07 = () => {
    this.setState(
      {
        expanded07: !this.state.expanded07,
      },
      () => {
        this.clearBuffer();
      },
    );
  };

  // handleExpandClick09 = () => {
  //     this.setState({
  //         expanded09: !this.state.expanded09,
  //         expanded10: this.state.expanded09,
  //         // next: false
  //     }, () => {
  //         this.clearReducer()
  //     })
  // }

  numberOnChange(field, max, event) {
    const { extraTimeDataReducer } = this.props;
    extraTimeDataReducer.extratime[0].benefittypeid = 2;
    const numbers = /^[0-9]+$/;
    if (field == "creditcompoff" || field == "maxearningcompoff") {
      this.setState({
        [field]: event.target.value,
      });
      extraTimeDataReducer.extratime[0][field] = event.target.value;
      this.props.ExtraTimeData({ ...extraTimeDataReducer });
    } else if (event.target.value.match(numbers)) {
      if (field == "combMin" || field == "combHours") {
        if (
          !Number.isNaN(event.target.value) &&
          parseInt(event.target.value) <= max
        ) {
          this.setState({ [field]: parseInt(event.target.value) }, () => {
            let hours = this.state.combHours;
            let minutes = this.state.combMin;
            if (hours < 10) {
              hours = `0${hours}`;
            }
            if (minutes < 10) {
              minutes = `0${minutes}`;
            }
            extraTimeDataReducer.extratime[0].requiredhour = `${hours}:${minutes}:00`;
          });
        }
      } else if (field == "maxearninghour" || field == "requiredhour") {
        if (
          !Number.isNaN(event.target.value) &&
          parseInt(event.target.value) <= max
        ) {
          this.setState({ [field]: parseInt(event.target.value) }, () => {
            let hours = this.state[field];
            if (hours < 10) {
              hours = `0${hours}`;
            }
            hours += ":00:00";
            extraTimeDataReducer.extratime[0][field] = hours;
          });
        }
      } else if (
        !Number.isNaN(event.target.value) &&
        Number(event.target.value) <= max
      ) {
        this.setState({ [field]: Number(event.target.value) }, () => {
          switch (field) {
            case "maxearninghour":
            case "requiredhour":
              {
                let hours = this.state[field];
                if (hours < 10) {
                  hours = `0${hours}`;
                }
                hours += ":00:00";
                extraTimeDataReducer.extratime[0][field] = hours;
              }
              break;
            case "buffertime":
              {
                let buffer = this.state.buffertime;
                if (buffer > 59) {
                  const hours = buffer / 60;
                  let rhours = Math.floor(hours);
                  let minutes = (hours - rhours) * 60;
                  minutes = Math.round(minutes);
                  if (minutes < 10) {
                    minutes = `0${minutes}`;
                  }
                  if (rhours < 10) {
                    rhours = `0${rhours}`;
                  }
                  extraTimeDataReducer.extratime[0][
                    field
                  ] = `${rhours}:${minutes}:00`;
                } else {
                  if (buffer < 10) {
                    buffer = `0${buffer}`;
                  }
                  extraTimeDataReducer.extratime[0][field] = `00:${buffer}:00`;
                }
              }
              break;
            // case "combHours":
            // case "combMin":
            //     {
            //         let hours = this.state.combHours
            //         let minutes = this.state.combMin
            //         if (hours < 10) { "0" + hours }
            //         if (minutes < 10) { "0" + minutes }
            //         extraTimeDataReducer.extratime[0]['requiredhour'] = hours + ":" + minutes + ":00"
            //     }
            default:
              extraTimeDataReducer.extratime[0][field] = Number(
                this.state[field],
              );
          }
          if (field == "accumulationmonths") {
            let isaccumulation = false;
            if (this.state.accumulationmonths > 0) isaccumulation = true;
            extraTimeDataReducer.extratime[0].isaccumulation = isaccumulation;
            this.setState({ isaccumulation });
          }

          this.props.ExtraTimeData({ ...extraTimeDataReducer });
        });
      }
    }
  }

  bufferCalOnChange() {
    const { extraTimeDataReducer } = this.props;
    this.setState(
      { isconsiderbuffertime: !this.state.isconsiderbuffertime },
      () => {
        extraTimeDataReducer.extratime[0].benefittypeid = 2;
        extraTimeDataReducer.extratime[0].isconsiderbuffertime =
          this.state.isconsiderbuffertime;
        this.props.ExtraTimeData({ ...extraTimeDataReducer });
      },
    );
  }

  validateNext = () => {
    this.setState({ error: [false, false, false, false] }, () => {
      if (this.state.isworkingbenefit == true) {
        if (this.state.expanded07) {
          if (this.state.buffertime == 0) {
            const { error } = this.state;
            error[4] = true;
            this.setState({ error });
            this.props.StepError(2, true);
          }
        }

        if (this.state.benefittypeid == 1) {
          if (this.state.isperhour) {
            if (this.state.maxearninghour == 0) {
              // let error = this.state.error
              // error[1] = true
              // this.setState({ error })
              this.setState({ error: [true, false, false, false, false] });
              this.props.StepError(2, true);
            } else if (!this.state.error[4]) {
              this.props.click();
              this.props.StepError(2, false);
            }
          } else if (!this.state.isperhour) {
            if (
              this.state.maxearninghour == 0 ||
              this.state.requiredhour == 0
            ) {
              this.setState({ error: [false, true, false, false, false] });
              this.props.StepError(2, true);
            } else {
              this.props.click();
              this.props.StepError(2, false);
            }
          } else if (!this.state.error[4]) {
            this.props.click();
            this.props.StepError(2, false);
          }
        } else if (this.state.benefittypeid == 2) {
          if (this.state.isperhour) {
            if (
              this.state.creditcompoff == 0 ||
              this.state.maxearningcompoff == 0
            ) {
              // let error = this.state.error
              // error[3] = true
              // this.setState({ error })
              this.setState({ error: [false, false, true, false, false] });
              this.props.StepError(2, true);
            } else if (
              this.state.maxearningcompoff < this.state.creditcompoff
            ) {
              this.props.enqueueSnackbar(
                `Employees should earn a minimum of ${this.state.creditcompoff} comp-off leaves in one day`,
                { variant: "error" },
              );
              this.props.StepError(2, true);
            } else if (!this.state.error[4]) {
              this.props.click();
              this.props.StepError(2, false);
            }
          } else if (!this.state.isperhour) {
            if (!this.state.combHours) {
              if (!this.state.combMin) {
                this.props.enqueueSnackbar("Please add comp-off hours", {
                  variant: "error",
                });
                this.props.StepError(2, true);
              }
            }
            if (
              this.state.creditcompoff == 0 ||
              this.state.maxearningcompoff == 0
            ) {
              this.setState({ error: [false, false, false, true, false] });
              this.props.StepError(2, true);
            } else if (
              this.state.maxearningcompoff < this.state.creditcompoff
            ) {
              this.props.enqueueSnackbar(
                `Employees should earn a minimum of ${this.state.creditcompoff} comp-off leaves in one day`,
                { variant: "error" },
              );
              this.props.StepError(2, true);
            } else if (this.state.isaccumulation) {
              if (!this.state.accumulationmonths) {
                this.props.enqueueSnackbar(
                  "Please enter accumulation month between 1 to 12",
                  { variant: "error" },
                );
                this.props.StepError(2, true);
              } else {
                this.props.click();
                this.props.StepError(2, false);
              }
            } else if (!this.state.error[4]) {
              this.props.click();
              this.props.StepError(2, false);
            }
          }
        }
      } else {
        this.props.click();
        this.props.StepError(2, false);
      }
    });
  };

  render() {
    const { classes } = this.props;
    const language = this.props.Language.extratimepolicy;

    return (
      <IntlProvider locale="en" messages={language} className="center">
        <div className="stepper-scroller padding-top-0">
          <div className="padding-bottom-30 stepper-scroller-content width80">
            <div className="inner-wrapper opaque">
              <p className="depedent-select-list-head">
                <FormattedMessage
                  id="__LbExtraTimeWorking"
                  defaultMessage="Do you wish to offer any benefit to employees for extra time (OT) spent on a working day?"
                />
              </p>
              <div
                className="depedent-select-list"
                onClick={this.handleExpandClick01}
                aria-expanded={this.state.isworkingbenefit}
              >
                <span>
                  <FormattedMessage id="LbYes" defaultMessage="Yes" />
                </span>
                {this.state.isworkingbenefit == true ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected"></span>
                )}
              </div>
              <div className="et-level2">
                <Collapse
                  in={this.state.isworkingbenefit}
                  timeout={2}
                  unmountOnExit
                  className="padding30 padding-top-5-5 overflow-initial"
                >
                  <div className="margin-top-20">
                    <p className="form-input-label">
                      <FormattedMessage
                        id="_LbBenefit"
                        defaultMessage="Please choose a benefit"
                      />
                    </p>
                    <div
                      className="depedent-select-list"
                      onClick={this.handleExpandClick03.bind(this, 2)}
                      aria-expanded={this.state.benefittypeid == 2}
                    >
                      <span>
                        <FormattedMessage
                          id="__LbCompOff"
                          defaultMessage="Give compensatory off against extra-time (OT)"
                        />
                      </span>
                      {this.state.benefittypeid == 2 ? (
                        <span className="floatright">
                          <img src={CheckImg} height="20" />
                        </span>
                      ) : (
                        <span className="not-selected"></span>
                      )}
                    </div>
                    <div className="et-level3">
                      <Collapse
                        in={this.state.benefittypeid == 2}
                        timeout={2}
                        unmountOnExit
                        className="padding30 padding-top-5-5 overflow-initial"
                      >
                        <div
                          className="depedent-select-list"
                          onClick={this.handleExpandClick05}
                          aria-expanded={this.state.isperhour == false}
                        >
                          <span
                            className="inline-block"
                            style={{ width: "94%" }}
                          >
                            <FormattedMessage
                              id="__LbCompOffCondition"
                              defaultMessage="Employees earn comp-off leaves only if the employee completes certain number of hours"
                            />
                          </span>
                          {this.state.isperhour == false ? (
                            <span className="floatright">
                              <img src={CheckImg} height="20" />
                            </span>
                          ) : (
                            <span className="not-selected"></span>
                          )}
                        </div>
                        <div className="et-level4">
                          <Collapse
                            in={this.state.isperhour == false}
                            timeout={2}
                            unmountOnExit
                            className="padding30 padding-top-5-5 overflow-initial"
                          >
                            <ul>
                              <li className="margin-top-20">
                                <span>
                                  <FormattedMessage
                                    id="LbMin"
                                    defaultMessage="Minimum"
                                  />
                                </span>
                                <InputValues
                                  min="0"
                                  max="23"
                                  field="combHours"
                                  onChange={this.numberOnChange.bind(
                                    this,
                                    "combHours",
                                    23,
                                  )}
                                  value={this.state.combHours}
                                  defaultvalue={this.state.combHours}
                                />
                                <span>
                                  <FormattedMessage
                                    id="__LbMin"
                                    defaultMessage="hour(s)"
                                  />
                                </span>
                                :
                                <InputValues
                                  min="0"
                                  max="59"
                                  field="combMin"
                                  onChange={this.numberOnChange.bind(
                                    this,
                                    "combMin",
                                    59,
                                  )}
                                  value={this.state.combMin}
                                  defaultvalue={this.state.combMin}
                                />
                                <span>
                                  <FormattedMessage
                                    id="__LbMin2"
                                    defaultMessage=" min(s) is required for an employee to earn"
                                  />
                                </span>
                                <span className="margin-top-8 inlindClass">
                                  <FloatValues
                                    min="0"
                                    max="500"
                                    step="0.25"
                                    field="creditcompoff"
                                    onChange={this.numberOnChange.bind(
                                      this,
                                      "creditcompoff",
                                      500,
                                    )}
                                    value={this.state.creditcompoff}
                                    defaultvalue={this.state.creditcompoff}
                                  />
                                </span>
                                <span>
                                  <FormattedMessage
                                    id="__LbCredits"
                                    defaultMessage="leave(s)"
                                  />
                                </span>
                              </li>
                              <li className="margin-top-20">
                                <div>
                                  <span>
                                    <FormattedMessage
                                      id="__LbAccumulated"
                                      defaultMessage="Can extra time hours be accumulated?"
                                    />
                                  </span>
                                  <span>
                                    <div>
                                      <Radio
                                        checked={this.state.isaccumulation}
                                        onChange={() =>
                                          this.accumulationchange(true)
                                        }
                                        value={this.state.isaccumulation}
                                        name="radio-button-demo"
                                        inputProps={{ "aria-label": "Yes" }}
                                      />
                                      <span>{"  Yes"}</span>
                                      <span style={{ marginLeft: 10 }}>
                                        <Tooltip
                                          classes={{
                                            tooltip: classes.customWidth,
                                          }}
                                          title={
                                            <span>
                                              <br />
                                              <span className="t-backgroundColor">
                                                Accumulative example
                                              </span>
                                              <br />
                                              <br />
                                              <span style={{ opacity: 0.7 }}>
                                                If the current month is August,
                                                Jay’s comp-off hours from
                                                August, July and June will be
                                                combined to give him 1 comp-off
                                                leave; assuming Jay has
                                                accumulated 3 hours in August, 2
                                                hours in July and 3 hours in
                                                June.
                                              </span>
                                              <br />
                                            </span>
                                          }
                                          placement="right"
                                        >
                                          <span>
                                            <i
                                              className="material-icons vertical-middle"
                                              style={{
                                                color: "#ddd",
                                                cursor: "default",
                                              }}
                                            >
                                              info
                                            </i>
                                          </span>
                                        </Tooltip>
                                      </span>
                                    </div>

                                    {this.state.isaccumulation && (
                                      <div
                                        style={{
                                          marginLeft: 45,
                                          marginTop: -18,
                                        }}
                                      >
                                        <span>
                                          <FormattedMessage
                                            id="LbAccumulated"
                                            defaultMessage="Hours can be accumulated over  "
                                          />
                                        </span>
                                        <InputValues
                                          min="0"
                                          max="12"
                                          field="accumulationmonths"
                                          onChange={this.numberOnChange.bind(
                                            this,
                                            "accumulationmonths",
                                            12,
                                          )}
                                          value={this.state.accumulationmonths}
                                          defaultvalue={
                                            this.state.accumulationmonths
                                          }
                                          disabled={!this.state.isaccumulation}
                                        />

                                        <span>
                                          <FormattedMessage
                                            id="LbMonths"
                                            defaultMessage=" Months"
                                          />
                                        </span>
                                      </div>
                                    )}
                                    <div>
                                      <Radio
                                        checked={!this.state.isaccumulation}
                                        onChange={() =>
                                          this.accumulationchange(false)
                                        }
                                        value={!this.state.isaccumulation}
                                        name="radio-button-demo"
                                        inputProps={{ "aria-label": "No" }}
                                      />
                                      <span>{"  No"}</span>
                                      <span style={{ marginLeft: 10 }}>
                                        <Tooltip
                                          classes={{
                                            tooltip: classes.customWidth,
                                          }}
                                          title={
                                            <span>
                                              <br />
                                              <span className="t-backgroundColor">
                                                Non-accumulative example
                                              </span>
                                              <br />
                                              <br />
                                              <span style={{ opacity: 0.7 }}>
                                                If the current month is August
                                                and Jay has updated past-dated
                                                attendance of June with 8
                                                comp-off hours, this will add 1
                                                comp-off leave to Jay’s account.
                                              </span>
                                              <br />
                                            </span>
                                          }
                                          placement="right"
                                        >
                                          <span>
                                            <i
                                              className="material-icons vertical-middle"
                                              style={{
                                                color: "#ddd",
                                                cursor: "default",
                                              }}
                                            >
                                              info
                                            </i>
                                          </span>
                                        </Tooltip>
                                      </span>
                                    </div>
                                  </span>
                                </div>
                              </li>
                              <li className="margin-top-20">
                                <span>
                                  <FormattedMessage
                                    id="__LbCombOffInADay"
                                    defaultMessage="Limit the number of comp-off leaves earned in one day to"
                                  />
                                </span>
                                <br />
                                <FloatValues
                                  min="0"
                                  max="500"
                                  step="0.25"
                                  field="maxearningcompoff"
                                  onChange={this.numberOnChange.bind(
                                    this,
                                    "maxearningcompoff",
                                    500,
                                  )}
                                  value={this.state.maxearningcompoff}
                                  defaultvalue={this.state.maxearningcompoff}
                                />
                              </li>
                            </ul>
                            {this.state.error[3] ? (
                              <div className="caption-error">
                                *Please select valid value.
                              </div>
                            ) : (
                              ""
                            )}
                          </Collapse>
                        </div>
                        <div
                          className="depedent-select-list margin-top-20"
                          onClick={this.handleExpandClick05}
                          aria-expanded={this.state.isperhour}
                        >
                          <span>
                            <FormattedMessage
                              id="LbCompOffEachHour"
                              defaultMessage="Employees earn comp-off leaves for each hour of extra time"
                            />
                          </span>
                          {this.state.isperhour ? (
                            <span className="floatright">
                              <img src={CheckImg} height="20" />
                            </span>
                          ) : (
                            <span className="not-selected"></span>
                          )}
                        </div>
                        <div className="et-level4">
                          <Collapse
                            in={this.state.isperhour}
                            timeout={2}
                            unmountOnExit
                            className="padding30 padding-top-5-5 overflow-initial"
                          >
                            <ul>
                              <li className="margin-top-20">
                                <span>
                                  <FormattedMessage
                                    id="LbEmployees receive"
                                    defaultMessage="Employees receive"
                                  />
                                </span>
                                <FloatValues
                                  min="0"
                                  max="500"
                                  step="0.25"
                                  field="creditcompoff"
                                  onChange={this.numberOnChange.bind(
                                    this,
                                    "creditcompoff",
                                    500,
                                  )}
                                  value={this.state.creditcompoff}
                                  defaultvalue={this.state.creditcompoff}
                                />

                                <span>
                                  <FormattedMessage
                                    id="__LbCreditEachHour"
                                    defaultMessage="leave(s) for each hour of extra time"
                                  />
                                </span>
                              </li>
                              <li className="margin-top-20">
                                <span>
                                  <FormattedMessage
                                    id="__LbCombOffInADay"
                                    defaultMessage="Limit the number of comp-off leaves earned in one day to"
                                  />
                                </span>
                                <br />
                                <FloatValues
                                  min="0"
                                  max="500"
                                  step="0.25"
                                  field="maxearningcompoff"
                                  onChange={this.numberOnChange.bind(
                                    this,
                                    "maxearningcompoff",
                                    500,
                                  )}
                                  value={this.state.maxearningcompoff}
                                  defaultvalue={this.state.maxearningcompoff}
                                />
                              </li>
                            </ul>
                            {this.state.error[2] ? (
                              <div className="caption-error">
                                *Please select valid value.
                              </div>
                            ) : (
                              ""
                            )}
                          </Collapse>
                        </div>
                      </Collapse>
                    </div>
                    {/* <div
                      className="depedent-select-list"
                      onClick={this.handleExpandClick03.bind(this, 1)}
                      aria-expanded={this.state.benefittypeid == 1}
                    >
                      <span>
                        <FormattedMessage
                          id="__LbPaid"
                          defaultMessage="Pay for extra-time (OT)"
                        />
                      </span>
                      {this.state.benefittypeid == 1 ? (
                        <span className="floatright">
                          <img src={CheckImg} height="20" />
                        </span>
                      ) : (
                        <span className="not-selected"></span>
                      )}
                    </div> */}
                    <div className="et-level3">
                      <Collapse
                        in={this.state.benefittypeid == 1}
                        timeout={2}
                        unmountOnExit
                        className="padding30 overflow-initial"
                      >
                        <div
                          className="depedent-select-list"
                          onClick={this.handleExpandClick05}
                          aria-expanded={this.state.isperhour == false}
                        >
                          <span
                            className="inline-block"
                            style={{ width: "94%" }}
                          >
                            <FormattedMessage
                              id="LbPaidPerHourCond"
                              defaultMessage="Pay per hour only if the employees complete certain number of extra time hours"
                            />
                          </span>
                          {this.state.isperhour == false ? (
                            <span className="floatright">
                              <img src={CheckImg} height="20" />
                            </span>
                          ) : (
                            <span className="not-selected"></span>
                          )}
                        </div>
                        <Collapse
                          in={this.state.isperhour == false}
                          timeout={2}
                          unmountOnExit
                          className="padding30 padding-top-5-5 overflow-initial"
                        >
                          <ul>
                            <li className="margin-top-20">
                              <span>
                                <FormattedMessage
                                  id="LbPaidHours"
                                  defaultMessage="Extra Time hours required to show payable earnings are"
                                />
                              </span>
                              <br />
                              <InputValues
                                min="0"
                                max="24"
                                field="requiredhour"
                                onChange={this.numberOnChange.bind(
                                  this,
                                  "requiredhour",
                                  24,
                                )}
                                value={this.state.requiredhour}
                                defaultvalue={this.state.requiredhour}
                              />
                            </li>
                            <li className="margin-top-20">
                              <span>
                                <FormattedMessage
                                  id="LbMaxPaidHours"
                                  defaultMessage="Limit the number of payable extra time hours earned in one day to "
                                />
                              </span>
                              <br />
                              <InputValues
                                min="0"
                                max="24"
                                field="maxearninghour"
                                onChange={this.numberOnChange.bind(
                                  this,
                                  "maxearninghour",
                                  24,
                                )}
                                value={this.state.maxearninghour}
                                defaultvalue={this.state.maxearninghour}
                              />
                            </li>
                          </ul>
                          {this.state.error[1] ? (
                            <div className="caption-error">
                              *Please select valid value.
                            </div>
                          ) : (
                            ""
                          )}
                        </Collapse>
                        <div
                          className="depedent-select-list"
                          onClick={this.handleExpandClick05}
                          aria-expanded={this.state.isperhour}
                        >
                          <span>
                            <FormattedMessage
                              id="LbPaidPerHour"
                              defaultMessage=" Pay per hour of extra time"
                            />
                          </span>
                          {this.state.isperhour ? (
                            <span className="floatright">
                              <img src={CheckImg} height="20" />
                            </span>
                          ) : (
                            <span className="not-selected"></span>
                          )}
                        </div>
                        <Collapse
                          in={this.state.isperhour}
                          timeout={2}
                          unmountOnExit
                          className="padding30 overflow-initial"
                        >
                          <span>
                            <FormattedMessage
                              id="LbPayInaDay"
                              defaultMessage="Limit the number of payable extra time hours earned in one day to "
                            />
                          </span>
                          <InputValues
                            min="0"
                            max="24"
                            field="maxearninghour"
                            onChange={this.numberOnChange.bind(
                              this,
                              "maxearninghour",
                              24,
                            )}
                            value={this.state.maxearninghour}
                            defaultvalue={this.state.maxearninghour}
                          />
                          {this.state.error[0] ? (
                            <div className="caption-error">
                              *Please select valid value.
                            </div>
                          ) : (
                            ""
                          )}
                        </Collapse>
                      </Collapse>
                    </div>
                  </div>
                  <p className="form-input-label margin-top-20">
                    <FormattedMessage
                      id="__LbBuffer"
                      defaultMessage="Do you wish to set a minimum threshold (mins) before which extra-time (OT) will not be considered for benefits?"
                    />
                  </p>
                  <div
                    className="depedent-select-list"
                    onClick={this.handleExpandClick07}
                    aria-expanded={this.state.expanded07}
                  >
                    <span>
                      <FormattedMessage id="LbYes" defaultMessage="Yes" />
                    </span>
                    {this.state.expanded07 == true ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected"></span>
                    )}
                  </div>
                  <div className="et-level3">
                    <Collapse
                      in={this.state.expanded07}
                      timeout={2}
                      unmountOnExit
                      className="padding30 padding-top-5-5 overflow-initial"
                    >
                      <ul style={{ listStyleType: "none" }}>
                        <li className="margin-top-20">
                          <span>
                            <FormattedMessage
                              id="__LbBufferTime"
                              defaultMessage="Minimum threshold is"
                            />
                          </span>
                          <InputValues
                            min="0"
                            max="300"
                            field="buffertime"
                            onChange={this.numberOnChange.bind(
                              this,
                              "buffertime",
                              300,
                            )}
                            value={this.state.buffertime}
                            defaultvalue={this.state.buffertime}
                          />
                          <span>
                            <FormattedMessage
                              id="LbMinutes"
                              defaultMessage="minutes"
                            />
                          </span>
                        </li>
                        <li className="margin-top-20">
                          <span>
                            <span className="width90 floatleft">
                              <FormattedMessage
                                id="__LbBufferCal"
                                defaultMessage="Note: this duration will be included in calculating extra-time, once the employee crosses the threshold"
                              />
                            </span>
                            <Checkbox
                              checked={!!this.state.isconsiderbuffertime}
                              onChange={this.bufferCalOnChange.bind(this)}
                              value={this.state.isconsiderbuffertime}
                              color="primary"
                              className=""
                            />
                          </span>
                        </li>
                      </ul>
                      {this.state.error[4] ? (
                        <div className="caption-error">
                          *Please select valid value.
                        </div>
                      ) : (
                        ""
                      )}
                    </Collapse>
                  </div>
                  <div
                    className="depedent-select-list"
                    onClick={this.handleExpandClick07}
                    aria-expanded={!this.state.expanded07}
                  >
                    <span>
                      <FormattedMessage
                        id="__LbNo"
                        defaultMessage="No, there is no minimum threshold"
                      />
                    </span>
                    {this.state.expanded07 == false ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected"></span>
                    )}
                  </div>
                </Collapse>
              </div>

              <div
                className="depedent-select-list "
                onClick={this.handleExpandClick01}
                aria-expanded={!this.state.isworkingbenefit}
              >
                <span>
                  <FormattedMessage id="LbNo" defaultMessage="No" />
                </span>
                {this.state.isworkingbenefit == false ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected"></span>
                )}
              </div>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

WorkingDay.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  extraTimeDataReducer: state.extraTimeDataReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      ExtraTimeData: (data) => ExtraTimeData(data),
      CommonReducerAction: (data) => CommonReducerAction(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(WorkingDay)));
